import { createScopedPrint } from './printScoped'

/**
 * createScopedPrint names for the screens that print a VisitSummaryDocument: the doctor's
 * Patient Summary tab ('patient-summary') and the shared visit summary modal used by the patient
 * portal and reception ('visit-summary'). Their body classes (printing-<name>) are what scope the
 * document's page setup below.
 */
export const VISIT_SUMMARY_PRINT_NAMES = {
  staff: 'patient-summary',
  modal: 'visit-summary'
} as const

const PAGE_NAME = 'visit-summary-a4'

const printingBodySelectors = Object.values(VISIT_SUMMARY_PRINT_NAMES)
  .map(name => `body.${createScopedPrint(name).printBodyClass}`)
  .join(',\n  ')

/**
 * Print CSS rendered by VisitSummaryDocument. An `@page` rule can't sit under a selector, so the A4
 * page setup is a NAMED page, used only while one of the visit summary scoped prints is active
 * (their class is on <body>) — mounting the document never changes how anything else prints
 * (invoices, prescriptions, lab reports…). Browsers without named-page support just print with
 * their default page box.
 */
export const visitSummaryDocumentCss = `@page ${PAGE_NAME} { size: A4; margin: 12mm; }
@media print {
  ${printingBodySelectors} { page: ${PAGE_NAME}; }
  .visit-summary-instructions { break-inside: avoid; page-break-inside: avoid; }
  .visit-summary-translation { break-before: page; page-break-before: always; }
}`
